module.exports = __webpack_public_path__ + "static/media/icon／icon_shangjiantou_1414_999999.95097fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon／icon_shangjiantou_1414_999999.png
// module id = 776
// module chunks = 0